export const desktopSize = 768;
export const mobileBigSize = 440;
export const resize = 'resize';
